/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, August 3rd 2022, 3:05:46 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/p
 */

import { schemaBuilder, fileBaseSchema, Many2OneUUIDPKBaseSchema } from "lib/validation";
import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
  DataBank,
} from "lib/schemas";
import { WritableModel } from "lib/schemas/abstract";
import { JsonSchema } from "./jsonSchemaInterface";

export interface DatasetSchema extends ProcessTemplateArtifact, WritableModel<true> {
  json_schema: JsonSchema;
  readonly entries_count?: number;
  data_bank: DataBank["id"];
}

const JSONSchemaValidationSchema: schemaBuilder.SchemaOf<Pick<JsonSchema, "title">> = schemaBuilder.object().shape({
  title: schemaBuilder.string().required("Dataset name is required"),
});

export const DatasetSchemaValidationSchema: ProcessTemplateArtifactSchemaType<
  Omit<DatasetSchema, "id" | "entries_count">
> = ProcessTemplateArtifactValidationSchema.shape({
  json_schema: JSONSchemaValidationSchema.required(),
  data_bank: Many2OneUUIDPKBaseSchema().required("A data bank is required for creating a dataset."),
});

export interface DatasetImportInput {
  csv_file: any;
}

export const DatasetImportInputValidationSchema: schemaBuilder.SchemaOf<DatasetImportInput> = schemaBuilder
  .object()
  .shape({
    csv_file: fileBaseSchema({ sizeLimit: 2097152 }).required("CSV file is required"),
  });
